export default {
  meta: {
    title: '角色设置'
  }
};
